module.exports = __webpack_public_path__ + "../resources/images/dismissal-x-2b4daff803dc72eb14426619d0b6d9cd.png";